module.exports = __webpack_public_path__ + "assets/webgl/card_063_EN_L0.jpg.a31e1aad.webp";